import { ApplicationConstants } from '../../shared/applicationConstants';
import { SharedService } from '../../shared/services/sharedService';

export class HomeService {
    static defaultGallerySortConcept = 'rank';

    static getHomePreviewMaps() {
        return SharedService.httpGetElements(ApplicationConstants.getHomePreviewMapsUrl);
    }

    static httpPostNewsletterSubscribe(formData) {
        return SharedService.httpPostBody(ApplicationConstants.postNewsletterSubscriptionUrl, formData);
    }
}



// WEBPACK FOOTER //
// ./src/home-geolocal/services/homeService.js